// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3Xpf2","bigColWidth":"Table_bigColWidth__1fJ9x","biggerColWidth":"Table_biggerColWidth__1kfZi","row":"Table_row__2w2u8","col":"Table_col__3ubvy"};